export default __webpack_public_path__ + "cba13c422be8639a59b17447a598f33f.png";